import { render, staticRenderFns } from "./FixedIncomeProducts.vue?vue&type=template&id=2055cf84&scoped=true"
import script from "./FixedIncomeProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./FixedIncomeProducts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FixedIncomeProducts.vue?vue&type=style&index=0&id=2055cf84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2055cf84",
  null
  
)

export default component.exports